// Make enum for the possible directions of the arrow click

const ArrowClick = Object.freeze({
    LEFT: "left",
    RIGHT: "right",
})

export default ArrowClick;